import { LitescribeAdapter } from './Litescribe';

export const adapters = [new LitescribeAdapter()];
